module.exports = __webpack_public_path__ + "img/Approved_Supplier-04.a913cb31.png";